import React from 'react';

type SvgbuyingProps = React.SVGProps<SVGSVGElement>;

const Svgbuying: React.FC<SvgbuyingProps> = (props) => (
  <svg
    {...props}
    height="24"
    width="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="5"
      cy="20"
      r="2"
      stroke="#5F6D7E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <circle
      cx="18"
      cy="20"
      r="2"
      stroke="#5F6D7E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M18 18H5.30769V2H3"
      stroke="#5F6D7E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M5 4L21 5.25L19.8571 14H5"
      stroke="#5F6D7E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default Svgbuying;
